export default {
  _id: 'in-waiting',
  meta: {},
};
